































import Vue, { PropType } from 'vue';
import { Image } from '@/modules/image';

export default Vue.extend({
  name: 'GImageCropFormInput',
  props: {
    owner: { type: String as PropType<string>, required: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    label: { type: String as PropType<string>, default: '' },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    name: { type: String as PropType<string>, default: '' },
    value: { type: Object as PropType<Image>, default: null },
    caution: { type: String as PropType<string>, default: '' },
    error: { type: Array as PropType<string[]>, default: () => [] },
    aspect: { type: Number, default: null },
    isCircle: { type: Boolean, default: false },
    showDragOver: { type: Boolean, default: false },
  },
  methods: {
    onInput(val: Image | null) {
      this.$emit('input', val);
    },
  },
});
